// import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import SideMenu from "./SideMenu";
// import { useNavigate } from "react-router-dom";
// import { useUpdateProfileMutation } from "../../redux/api/userApi";
// import toast from "react-hot-toast";

// const UpdateProfile = () => {
//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");


//   const navigate = useNavigate();

//   const [updateProfile, { isLoading, error, isSuccess }] =
//     useUpdateProfileMutation();

//   const { user } = useSelector((state) => state.auth);

 

//   useEffect(() => {
//     if (user) {
//       setName(user?.name);
//       setEmail(user?.email);
//     }

//     if (error) {
//       toast.error(error?.data?.message);
//     }

//     if (isSuccess) {
//       toast.success("Info Updated");
//       navigate("/me/profile");
//     }
//   }, [user, error, isSuccess, navigate]);


//   const handleUpdate = (e) => {
//     e.preventDefault();

//     const userData = {
//       name,
//       email,
//     };

//     console.log("Submitting:", userData);
//     updateProfile(userData);
//   };


//   return (
//     <section className="max-w-2xl mx-auto md:justify-around md:flex my-16 px-6 py-12 bg-[#f5f5dc] ">
//       <SideMenu />

//       <form
//         onSubmit={handleUpdate}
//         className="flex flex-col space-y-6 w-full  md:px-8 mt-8 md:mt-0"
//       >
//         <h2 className="text-2xl font-playfair text-amber-700 mb-2">
//           Edit Profile
//         </h2>

//         {/* Name */}
//         <div>
//           <label
//             htmlFor="name"
//             className="block text-sm font-sourcesans text-stone-700 mb-1"
//           >
//             Name
//           </label>
//           <input
//             id="name"
//             type="text"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             className="w-full px-4 py-2 border border-stone-300 text-stone-800 placeholder-stone-500 bg-white font-sourcesans rounded-md focus:outline-none focus:ring-amber-600 focus:border-amber-600"
//             placeholder="Your name"
//           />
//         </div>

//         {/* Email */}
//         <div>
//           <label
//             htmlFor="email"
//             className="block text-sm font-sourcesans text-stone-700 mb-1"
//           >
//             Email
//           </label>
//           <input
//             id="email"
//             type="email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             className="w-full px-4 py-2 border border-stone-300 text-stone-800 placeholder-stone-500 bg-white font-sourcesans rounded-md focus:outline-none focus:ring-amber-600 focus:border-amber-600"
//             placeholder="you@example.com"
//           />
//         </div>

       

//         {/* Submit */}
//         <div>
//           <button
//             type="submit"
//             disabled={isLoading}
//             className="bg-amber-700 hover:bg-amber-800 text-white px-6 py-2 rounded-md text-sm font-sourcesans focus:outline-none focus:ring-2 focus:ring-amber-600"
//           >
//             {isLoading ? "Saving changes..." : "Save changes"}
//           </button>
//         </div>
//       </form>
//     </section>
//   );
// };

// export default UpdateProfile;


import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SideMenu from "./SideMenu";
import { useNavigate } from "react-router-dom";
import { useUpdateProfileMutation } from "../../redux/api/userApi";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet-async";

const UpdateProfile = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const navigate = useNavigate();

  const [updateProfile, { isLoading, error, isSuccess }] =
    useUpdateProfileMutation();

  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      setName(user?.name);
      setEmail(user?.email);
    }

    if (error) {
      toast.error(error?.data?.message);
    }

    if (isSuccess) {
      toast.success("Info Updated");
      navigate("/me/profile");
    }
  }, [user, error, isSuccess, navigate]);

  const handleUpdate = (e) => {
    e.preventDefault();

    const userData = { name, email };
    updateProfile(userData);
  };

  const menuItems = [
    { name: "Profile", url: "/me/profile" },
    { name: "Edit Profile", url: "/me/update_profile" },
    { name: "Change Password", url: "/me/update_password" },
    { name: "Orders", url: "/me/orders" },
  ];


  return (
    <>
    <Helmet>
        <title>My Orders</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
    <section className="max-w-2xl mt-20 md:mt-48 mx-auto md:flex my-16 px-6 py-12 bg-[#f5f3ea] shadow-md rounded-md">
      <SideMenu menuItems={menuItems}/>

      <form
        onSubmit={handleUpdate}
        className="flex flex-col space-y-6 w-full md:px-8 mt-8 md:mt-0 bg-white/70 backdrop-blur-sm p-6 rounded-md shadow-inner"
      >
        <h2 className="text-2xl font-playfair text-[#BC3F4A] mb-4 text-center md:text-left">
          Edit Profile
        </h2>

        {/* Name */}
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-sourcesans text-[#1c1917] mb-1"
          >
            Name
          </label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Your name"
            className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
          />
        </div>

        {/* Email */}
        <div>
          <label
            htmlFor="email"
            className="block text-sm font-sourcesans text-[#1c1917] mb-1"
          >
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            className="w-full px-4 py-2 border border-[#8a4b32]/50 bg-white text-[#1c1917] placeholder-stone-500 font-sourcesans rounded-md focus:outline-none focus:ring-amber-500 focus:border-amber-500 transition"
          />
        </div>

        {/* Submit */}
        <div>
          <button
            type="submit"
            disabled={isLoading}
            className="bg-[#BC3F4A] hover:bg-[#a3323b] text-white px-6 py-2 rounded-md text-sm font-playfair focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition w-full"
          >
            {isLoading ? "Saving changes..." : "Save changes"}
          </button>
        </div>
      </form>
    </section>
    </>
  );
};

export default UpdateProfile;

